var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-view',{on:{"load-finished":_vm.emitLoadFinished,"update-simulation-exam-menu-icon":_vm.emitUpdateSimulationExamMenuIcon}})
}
var staticRenderFns = []

export { render, staticRenderFns }